import { Box, Button } from '@mui/material';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { usePage } from 'contexts/Page/Page';
import { resolveKromaticSiteUrl } from 'helpers';
import { useRouter } from 'next/router';

export default function WizardButton({ action, color, dataTestId, label, lesson, link, onAction }: WizardButtonProps) {

    const analytics = useAnalytics();
    const page = usePage();
    const router = useRouter();

    function handleClick() {
        // Handle action, page change or link
        if (action && onAction) {
            onAction(action);
        } else if (lesson) {
            page.show(lesson);
        } else if (link?.startsWith('/')) {
            router.push(link);
        } else if (link) {
            window.open(resolveKromaticSiteUrl(link));
        }

        void analytics.trackActionEvent('action_tool_step_completed', {
            resource_id: lesson || action || label,
            resource_type: 'step',
            source: 'wizard_button',
        });
        if (action === 'finish' || lesson === 'finish') {
            void analytics.trackActionEvent('action_tool_completed', {
                resource_id: lesson || action || 'finish',
                resource_type: 'tool',
                source: 'wizard_button',
            });
        }
    }

    const ariaLabel = typeof label === 'string' ? label.replace(/<[^>]*>/g, '').trim() : '';
    return (
        <Button
            aria-label={ariaLabel || undefined}
            color={color as any}
            data-testid={dataTestId ?? 'wizard-button'}
            disableElevation={false}
            fullWidth
            onClick={handleClick}
        >
            <Box component="span" dangerouslySetInnerHTML={{ __html: label }} sx={{
                textAlign: 'center'
            }} />
        </Button>
    );

}
